import statusCodes from 'constants/statusCodes';
import { FEATURED, NOT_FEATURED } from 'constants/dataLayer';


export const getErrorString = (errorCode: (number|null)) => {
  switch (errorCode) {
    case statusCodes.NOT_FOUND:
      return 'NotFound';

    default:
      return 'Error';
  }
};

export const getFeaturedString = (featured: boolean) => {
  if (featured) {
    return FEATURED;
  }
  return NOT_FEATURED;
};
